import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../common/state';
import { EMetroTravelType } from '../../../json_query';
import { TTag } from '../../state/tags';
import { IKpIdTag } from '../../state/tags/definitions/kp_id';

import { Tags } from './index';
import { isFiltersDropdownExperimentActive } from '../../../experiments/filtersDropdown';
import { isFiltersDropdownSuburbanExperimentActive } from '../../../experiments/filtersDropdownSuburban';
import { isFiltersRedesignExperimentEnabled } from '../../../selectors/isFiltersRedesignExperimentEnabled';
import {
  offerTypeFromJsonQuery,
  dealTypeFromJsonQuery,
  FDealType,
  isUrban,
  isSuburban,
  FOfferType,
} from '../../../utils/category';

export const TagsContainer = connect(
  (state: IAppState) => {
    const jsonQuery = (state.filters.backup && state.filters.backup.jsonQuery) || state.filters.jsonQuery;
    const tags = state.filters.backup ? state.filters.backup.tags : state.filters.tags;
    const kpIdTag = tags.find(({ type }) => type === 'kp-id') as IKpIdTag;

    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const dealType = dealTypeFromJsonQuery(jsonQuery);

    if (kpIdTag && state.villageName) {
      kpIdTag.text = state.villageName;
    }

    return {
      isNewAdvancedFilters:
        (dealType === FDealType.Sale && (offerType & (FOfferType.Urban & ~FOfferType.FlatNew)) !== 0) ||
        ((dealType & FDealType.Rent) !== 0 &&
          isUrban(offerType) &&
          isFiltersDropdownExperimentActive(state.experiments)) ||
        (isSuburban(offerType) && isFiltersDropdownSuburbanExperimentActive(state.experiments)),
      userIsAuthenticated: state.user.isAuthenticated,
      isFitInOneLineEnabled: state.filters.tagsOptions.isFitInOneLineEnabled,
      tags,
      travelType: (jsonQuery.only_foot && jsonQuery.only_foot.value) || EMetroTravelType.Any,
      travelTime: jsonQuery.foot_min && jsonQuery.foot_min.value.lte,
      jsonQuery,
      withNewTag: isFiltersRedesignExperimentEnabled(state),
    };
  },
  (dispatch: Dispatch) => ({
    onTagDeleted: (tag: TTag, index: number) => {
      dispatch({
        type: 'filters/tags/TAG_REMOVED',
        tag,
        index,
      });
    },
    onAllTagsDeleted: () => {
      dispatch({
        type: 'filters/tags/ALL_TAGS_REMOVED',
      });
    },
  }),
)(Tags);
